import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  assetDataService,
  assetSharedModelService
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './copy-asset-dialog.controller';
import template from './copy-asset-dialog.html';
import nameMessagesTpl from '../dialog.editAssetDialog/messages/asset.name.messages.html';
import nameValidator, { name as validatorName } from '../dialog.editAssetDialog/messages/unique-asset-name.validator.directive';
import prefixValidator, {
  name as validatorPrefix,
} from '../dialog.editAssetDialog/messages/unique-asset-prefix.validator.directive';
import prefixMessagesTpl from '../dialog.editAssetDialog/messages/asset.prefix.messages.html';

export class dialogService {
  getOptions($event, { asset, updateCallBack }) {
    return {
      controller,
      controllerAs: 'copyAssetDialogVM',
      locals: {
        asset,
        updateCallBack,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular
  .module('app.components.admin.assetAdministration.copyAssetDialog', [
    ssDialogService,
    loaderService,
    assetDataService,
    alerts,
    assetSharedModelService,
  ])
  .directive(validatorName, nameValidator)
  .directive(validatorPrefix, prefixValidator)
  .service('copyAssetDialog', dialogService)
  .run($templateCache => {
    $templateCache.put('asset.name.messages.html', nameMessagesTpl);
    $templateCache.put('asset.prefix.messages.html', prefixMessagesTpl);
  }).name;

console.log('app.components.admin.assetAdministration.copyAssetDialog created');
